// extracted by mini-css-extract-plugin
module.exports = {"blockTitle":"header-plans_blockTitle__1ED-h","selector":"header-plans_selector__2ndsg","active":"header-plans_active__3IXV-"};